import type {
  SavedDashboardList,
  SelectedJobStatusFilterColumnsData,
  HiringPipelineFilters,
  SelectedInterviewFilterColumnsData,
  SelectedPipelineVelocityFilterColumnsData,
  SelectedPipelineVelocityDrilldownFilterColumnsData,
} from 'src/types/analytics-genesis';
import {
  CLEAR_SELECTED_FILTERS,
  SET_SELECTED_DATE_RANGE,
  RECEIVE_SAVED_DASHBOARDS,
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_FILTERS,
  RECEIVE_INTERVIEW_TABLE_COLUMNS,
  RECEIVE_JOB_STATUS_TABLE_COLUMNS,
  RECEIVE_PIPELINE_VELOCITY_TABLE_COLUMNS,
  RECEIVE_PIPELINE_VELOCITY_DRILLDOWN_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-hiring-pipeline';
import type {HiringPipelineActions} from 'src/action-creators/analytics/analytics-hiring-pipeline';
import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';


export type AnalyticsHiringPipelineState = {
  savedDashboards: SavedDashboardList;
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  selectedJobFilters: HiringPipelineFilters;
  pipelineVelocityTableColumnFilter: SelectedPipelineVelocityFilterColumnsData | null;
  pipelineVelocityDrilldownTableColumnFilter: SelectedPipelineVelocityDrilldownFilterColumnsData | null;
  jobStatusAgeTableColumnFilter: SelectedJobStatusFilterColumnsData | null;
  interviewScheduleTableColumnFilter: SelectedInterviewFilterColumnsData | null;
};

const initialState: AnalyticsHiringPipelineState = {
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  currentDashboardID: null,
  selectedJobFilters: {
    job_id: [],
    job_department: [],
    job_location: [],
    job_source: [],
    job_recruiter: [],
  },
  savedDashboards: [],
  interviewScheduleTableColumnFilter: null,
  pipelineVelocityTableColumnFilter: null,
  pipelineVelocityDrilldownTableColumnFilter: null,
  jobStatusAgeTableColumnFilter: null,
};

export default (
  state: AnalyticsHiringPipelineState = initialState,
  action: HiringPipelineActions,
): AnalyticsHiringPipelineState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }

    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }

    case SET_SELECTED_FILTERS: {
      const {selectedJobFilters} = state;
      return {
        ...state,
        selectedJobFilters: {
          ...selectedJobFilters,
          ...action.payload,
        },
      };
    }

    case CLEAR_SELECTED_FILTERS: {
      return {
        ...state,
        selectedJobFilters: {
          job_id: [],
          job_department: [],
          job_location: [],
          job_source: [],
          job_recruiter: [],
        },
      };
    }
    case RECEIVE_INTERVIEW_TABLE_COLUMNS: {
      return {...state, interviewScheduleTableColumnFilter: action.payload};
    }

    case RECEIVE_JOB_STATUS_TABLE_COLUMNS: {
      return {...state, jobStatusAgeTableColumnFilter: action.payload};
    }

    case RECEIVE_PIPELINE_VELOCITY_TABLE_COLUMNS: {
      return {...state, pipelineVelocityTableColumnFilter: action.payload};
    }

    case RECEIVE_PIPELINE_VELOCITY_DRILLDOWN_TABLE_COLUMNS: {
      return {
        ...state,
        pipelineVelocityDrilldownTableColumnFilter: action.payload,
      };
    }
  }
  return state;
};
